/*
 * Copyright (c) 2024. Amazon.com, Inc. or its affiliates. All rights reserved.
 */

import type { AuthTokenProvider } from '@amzn/vinyl-amzn'
import type { ObservableValue } from '@amazon/vinyl-observable'

export enum AuthStatus {
    /**
     * The customer is currently signed in.
     */
    SIGNED_IN = 'signedIn',

    /**
     * The customer is currently signed out.
     */
    SIGNED_OUT = 'signedOut',

    /**
     * The authentication state is pending.
     */
    PENDING = 'pending',
}

export interface Auth {
    status: ObservableValue<AuthStatus>

    /**
     * An alias to `status.value === AuthStatus.SIGNED_IN`
     */
    isSignedIn(): boolean

    /**
     * Returns the auth token provider, or throws if not signed in.
     */
    get authTokenProvider(): AuthTokenProvider

    signIn(): void
    signOut(): void
}
